const api = {
  clockIn: () => `/account/clockin`,
  clockOut: () => `/account/clockout`,
  activeClock: (timeZoneOffset) => `/account/active-clock/${timeZoneOffset}`,
  getTimeClockByPayPeriod: (internetUserId, payPeriodId) => `/account/${internetUserId}/payperiods/${payPeriodId}/timeclock`,
  addTimeClock: (internetUserId) => `/account/${internetUserId}/timeclock`,
  deleteTimeClock: (id) => `/account/timeclock/${id}`,
  updateTimeClock: (id) => `/account/timeclock/${id}`,
  getEmployeesByPayPeriod: (internetUserId, payPeriodId) => `/account/managers/${internetUserId}/payperiods/${payPeriodId}/employees`,
  approvePayPeriodUser: (payPeriodId, internetUserId) => `/account/payperiods/${payPeriodId}/employees/${internetUserId}`,
  getEmployeeDetails: (internetUserId) => `/account/employees/${internetUserId}/details`,
  updateEmployeeDetails: (internetUserId) => `/account/employees/${internetUserId}/details`,
  getEmployeeNotes: (internetUserId) => `/account/employees/${internetUserId}/notes`,
  addEmployeeNote: (internetUserId) => `/account/employees/${internetUserId}/notes`,
};

export { api };